import React from 'react'
import { colors } from '@lmc/common/constants'
import { CSSProperties, ReactNode } from 'react'
import Text from '../../atoms/Text'

export type ListSectionHeaderProps = {
  title: string
  titleIcon?: ReactNode
  icon?: ReactNode
  style?: CSSProperties
  shortCut?: string
}

const ListSectionHeader = ({
  title,
  titleIcon,
  icon,
  style,
  shortCut,
}: ListSectionHeaderProps) => {
  const componentStyles = {
    container: { display: 'flex' },
    defaultIcon: {
      backgroundColor: colors.darkblue,
      color: colors.white,
      marginRight: 0,
      width: 40,
      height: 40,
      borderRadius: 4,
      fontWeight: 700,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 10,
    },
    info: {
      width: '100%',
      borderBottom: `2px solid ${colors.black}`,
    },
  }

  return (
    <div style={{ ...componentStyles.container, ...style }}>
      <Text style={componentStyles.info} as="h5">
        {title}
        {titleIcon}
      </Text>
      {icon || <div style={componentStyles.defaultIcon}>{shortCut}</div>}
    </div>
  )
}

export default ListSectionHeader
